/*
 * @Description: 活跃成员列表弹窗组件
 * @LastEditors: yingongjing
 * @LastEditTime: 2025-09-22 20:36:56
 */

import React, { useCallback } from 'react'
import './index.scss'
import { MemberInfo } from '../../index'
import classNames from 'classnames'
import { Button, Avatar } from 'antd'
import { EnvironmentOutlined, UserOutlined } from '@ant-design/icons'

interface IMemberListProps {
  open: boolean
  memberList: any[]
  totalCount: number
  onClose: () => void
  onMemberClick: (member: any) => void
}

const MemberList: React.FC<IMemberListProps> = ({
  open,
  memberList,
  totalCount,
  onClose,
  onMemberClick
}) => {
  // 处理成员点击
  const handleMemberClick = useCallback(
    (member: MemberInfo) => {
      onMemberClick(member)
    },
    [onMemberClick]
  )

  if (!open) return null

  return (
    <div className={`active-member-list ${open ? '' : 'close'}`}>
      <div className="member-list-container">
        <div className="member-list-header">
          <div className="header-controls">
            <button className="back-btn" onClick={onClose}>
              <span className="back-icon">←</span>
              返回
            </button>
          </div>
        </div>
        <div className="member-list-content">
          {memberList && memberList.length > 0 ? (
            memberList.map((member, index) => (
              <div
                key={member.userId}
                className="member-item"
                onClick={() => handleMemberClick(member)}
              >
                <Avatar
                  className="member-avatar"
                  size={40}
                  icon={<UserOutlined />}
                  src={member.headimgurl}
                />
                <div className="member-info">
                  <div className="member-name-department">
                    <span className="member-name">{member.userName}</span>{' '}
                    {member.groupName && (
                      <span className="member-group-department">
                        {member.groupName}
                      </span>
                    )}
                    {member.departmentName && (
                      <span className="member-group-department">
                        {' 丨 '}
                        {member.departmentName}
                      </span>
                    )}
                  </div>
                  <div className="member-status">
                    <span
                      className={`status-dot ${
                        member.active ? 'active' : 'inactive'
                      }`}
                    ></span>
                    <span
                      className={`status-text ${
                        member.active ? 'active' : 'inactive'
                      }`}
                    >
                      {member.activeInfo}
                    </span>
                  </div>
                  <div className="member-address">{member.address}</div>
                </div>

                <div className="member-action">
                  <EnvironmentOutlined className="location-icon" />
                  <span className="action-text">定位</span>
                </div>
              </div>
            ))
          ) : (
            <div className="empty-state">
              <div className="empty-icon">👥</div>
              <div className="empty-text">暂无活跃成员</div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default MemberList
